export enum SituacaoCadastroFamiliaUsuario {
  USUARIO_COM_FAMILIA_CADASTRADA = 'USUARIO_COM_FAMILIA_CADASTRADA',
	USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO = 'USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO',
	USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO = 'USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO',
	USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO = 'USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO',
	USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO = 'USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO',
  USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO = 'USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO',
  USUARIO_COM_PRAZO_CADASTRO_DECORRIDO = 'USUARIO_COM_PRAZO_CADASTRO_DECORRIDO'
}
